module.exports = __webpack_public_path__ + "files/890406cff91e726751b1c3d8e60c6c14.png";